import type { FC } from 'react';

import { HelpText } from '@pp/core/src/services/helpTranslations/reactBindings/HelpText';

export const HelpChapterCrashDisconnectionPolicy: FC = () => {

  return (
    <div>
      <p>
        <HelpText tk="disconnectionPolicy.disconnection" />
      </p>
      <ul>
        <li>
          <HelpText tk="disconnectionPolicy.disconnectionBefore" markdown />
        </li>
        <li>
          <HelpText tk="disconnectionPolicy.disconnectionAfter" markdown />
        </li>
        <li>
          <HelpText tk="disconnectionPolicy.forcedCashout" markdown />
        </li>
      </ul>
      <p>
        <HelpText tk="disconnectionPolicy.contactSupport" markdown />
      </p>
      <p>
        <HelpText tk="disconnectionPolicy.contactCustomerSupport" />
      </p>
    </div>
  );
};
